import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useFileInput, { FileInput, FileList } from "@/components/form/file-input";
import useTextInput, { TextInput } from "@/components/form/text-input";

const S16 = (props) => {
    const file = useFileInput({
        label: "Har du kjøpekontrakten tilgjengelig?",
        required: false,
        multiple: true,
    })

    const text = useTextInput({
        name: "info[miscellaneous][description]",
        label: "Er det noe mer du ønsker å legge til som vi bør vite?",
        placeholder: "Skriv her...",
        className: "mt-7",
        required: false,
        ...props,
    })

    return (
        <Wrapper {...props} header="Og helt til slutt...">
            <FileInput {...file}/>
            <FileList className="mt-3"/>
            <TextInput {...text.props}/>
        </Wrapper>
    );
};

export default S16;
